import { render } from "./HeroiconsSolidHome.vue?vue&type=template&id=34e49d75"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidHome.vue"]])

export default __exports__